import React from "react";
import { Card, Dropdown } from "react-bootstrap";
import { FiFileText } from "react-icons/fi";
import {
  AreaChart,
  Area,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

const data = [
  { name: "1", value: 10 },
  { name: "2", value: 30 },
  { name: "3", value: 15 },
  { name: "4", value: 40 },
  { name: "5", value: 20 },
  { name: "6", value: 50 },
  { name: "7", value: 18 },
  { name: "8", value: 35 },
  { name: "9", value: 12 },
  { name: "10", value: 45 },
];

export default function CertificationCompleted() {
  return (
    <Card className="h-100"
      style={{
        padding: 20,
        borderRadius: "6px",
        border: "2px solid #eee",
        background: "#ffffff",
        fontFamily: "Inter, sans-serif",
     
      
       
     

      }}
    >
      {/* HEADER */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div></div>


      </div>

      {/* CONTENT */}
      <div style={{ textAlign: "center", marginTop: 10 }}>
        <div
          style={{
            width: 45,
            height: 45,
            borderRadius: "50%",
            background: "#f1f5f9",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto",
            color: "#64748b",
          }}
        >
          <FiFileText size={20} />
        </div>

        <h6 style={{ marginTop: 12, fontWeight: 600 }}>
          Certification Completed
        </h6>

        <h4 style={{ fontWeight: 700 }}>225</h4>

        <div
          style={{
            background: "#dcfce7",
            color: "#16a34a",
            display: "inline-block",
            padding: "4px 10px",
            borderRadius: 20,
            fontSize: 12,
          }}
        >
          ↑ 12%
        </div>

        <p style={{ fontSize: 12, color: "#6b7280", marginTop: 5 }}>
          from last month
        </p>
      </div>

      {/* GRAPH */}
      <div style={{ width: "100%", height: 180 }}>
        <ResponsiveContainer>
          <AreaChart data={data}>
            {/* GRADIENT */}
            <defs>
              <linearGradient id="colorOrange" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#f97316" stopOpacity={0.4} />
                <stop offset="100%" stopColor="#f97316" stopOpacity={0} />
              </linearGradient>
            </defs>

            {/* TOOLTIP */}
            <Tooltip
              contentStyle={{
                background: "#fff",
                borderRadius: 8,
                border: "1px solid #eee",
                fontSize: 13,
              }}
              labelStyle={{ color: "#6b7280" }}
              formatter={(value) => [`Performance: ${value}`, ""]}
            />

            {/* LINE */}
            <Area
              type="monotone"
              dataKey="value"
              stroke="#ea580c"
              strokeWidth={3}
              fill="url(#colorOrange)"
              dot={false}
              activeDot={{
                r: 5,
                fill: "#ea580c",
                stroke: "#fff",
                strokeWidth: 2,
              }}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
}